// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".waiting-row--qOCog{--bs-border-style: dashed;color:#96a0b4}.running-dot--oPJYR{width:8px;height:8px;border-radius:50%;background-color:#35b864}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"waiting-row": "waiting-row--qOCog",
	"running-dot": "running-dot--oPJYR"
};
export default ___CSS_LOADER_EXPORT___;
